import { InjectionToken } from '@angular/core';
import { Parent, Title } from '../entities';
import { INavData } from '@coreui/angular';


export interface LayoutConfiguration {
  languages: { code: string; name: string }[];
  navigation: INavData[];
}

export const LAYOUT_CONFIGURATION_TOKEN = new InjectionToken<
  LayoutConfiguration
>(`Configure Layout Configuration For UI Layouts Module`);
